<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orderStateOptions: [], // 状态
        form: [
          { // 结算月份
            label: '结算月份',
            value: 'settleMonth',
            type: 'date',
            placeholder: '请选择结算月份',
            disabled: true,
            default: this.$route.query.settleMonth,
            attr: {
              type: 'month',
            },
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'carDriverName',
            type: 'input',
            disabled: true,
            default: decodeURIComponent(this.$route.query.carDriverName),
            placeholder: '请输入司机姓名',
          },
          { // 司机手机
            label: '司机手机',
            value: 'carDriverPhone',
            type: 'input',
            disabled: true,
            default: this.$route.query.carDriverPhone,
            placeholder: '请输入司机手机',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        salaryId: this.$route.query.salaryId,
        settleMonth: this.$route.query.settleMonth,
        carDriverId: this.$route.query.carDriverId,
        carDriverPhone: this.$route.query.carDriverPhone,
        carDriverName: decodeURIComponent(this.$route.query.carDriverName),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
